import { clamp } from './math';

/** Button bits. Strike, grapple and signature act on the press; defend acts while held. */
export const BUTTON = {
  strike: 1,
  grapple: 2,
  defend: 4,
  signature: 8,
} as const;

/**
 * One fighter's input for one tick. mx/my is the move direction (length ≤ 1, y down).
 * `buttons` holds every button that was down at any moment since the previous tick, so a tap
 * shorter than a tick is never lost.
 */
export interface FighterInput {
  mx: number;
  my: number;
  buttons: number;
}

export const NO_INPUT: FighterInput = { mx: 0, my: 0, buttons: 0 };

/** Axis values travel as int8 online; the sim always works with the quantized value. */
export function quantizeAxis(v: number): number {
  return Math.round(clamp(v, -1, 1) * 127) / 127;
}

export function quantizeInput(input: FighterInput): FighterInput {
  let mx = quantizeAxis(input.mx);
  let my = quantizeAxis(input.my);
  const lenSq = mx * mx + my * my;
  if (lenSq > 1) {
    const inv = 1 / Math.sqrt(lenSq);
    mx *= inv;
    my *= inv;
  }
  return { mx, my, buttons: input.buttons & 15 };
}
